import {useState} from 'react';
import { db } from '../../../firebase';
import { doc, updateDoc, collection, query, where, getDocs, getDoc, setDoc } from "firebase/firestore";

import styles from "./Sidebar.module.css"

import {VscSymbolColor} from "react-icons/vsc"
import {BiBorderRadius} from "react-icons/bi"
import {HiOutlineDuplicate} from "react-icons/hi"
import {MdMinimize, MdPhotoSizeSelectLarge} from "react-icons/md"
import {BsBorderOuter} from "react-icons/bs"

import SidebarCard from '../../SidebarCard/SidebarCard';

import BackgroundOptions from './BackgroundOptions/BackgroundOptions'
import PaddingOptions from "./PaddingOptions/PaddingOptions"
import ShadowOptions from './ShadowOptions/ShadowOptions'

import { useAuth } from '../../../contexts/authContext';

import html2canvas from "html2canvas";
import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';

import { useScreenshot, createFileName } from "use-react-screenshot";

import * as htmlToImage from 'html-to-image';
import download from 'downloadjs';

import { getDownloadURL, getStorage, ref, uploadString } from "firebase/storage";

const uuid = require("uuid")

export default function Sidebar(props) {
  const {currentUser} = useAuth()

  const [sidebarWidth, setSidebarWidth] = useState(300);
  const [minimisedSidebar, setMinimisedSidebar] = useState(false);

  const [saving, setSaving] = useState(false);

  const gradient = `linear-gradient(45deg, ${(props.bgValueGradient && props.bgValueGradient[0])} 0%, ${(props.bgValueGradient && props.bgValueGradient[1])} 100%)`;
  const solid = props.bgValueSolid;

  const searchParams = new URLSearchParams(window.location.href)

  const storage = getStorage();
  const storageRef = ref(storage, `${currentUser.uid} ${searchParams.get("designId")}'s thumbnail`);

  async function saveDesign() {
    setSaving(true)

    document.body.style.cursor="wait"

    const docRef = doc(db, "users", currentUser.uid);

    const obj = {};

    obj.allDesigns = {}

    htmlToImage.toPng(props.testRef.current)
      .then(async function (dataUrl) {
        const message4 = dataUrl;
        
        await uploadString(storageRef, message4, 'data_url').then(async (snapshot) => {
          const thumbnailURL = await getDownloadURL(storageRef)

          obj.allDesigns[searchParams.get("designId")] = {
            bgBorderRadius: props.bgBorderRadius,
            bgGradientColor: props.bgValueGradient,
            bgGradientRotation: props.bgGradientRotation,
            bgSolidColor: props.bgValueSolid,
            bgPadding: props.padding,
            bgTopPadding: props.topPadding,
            bgLeftPadding: props.leftPadding,
            bgBottomPadding: props.bottomPadding,
            bgRightPadding: props.rightPadding,
            bgLinkedPadding: props.linkedPadding,
            bgType: props.bgType,
            imgBorderRadius: props.imgBorderRadius,
            thumbnailUrl: thumbnailURL || null,
            // imgSrc: props.userImage || null,
            imgShadow: {
              enabled: props.shadowEnabled,
              blurRadius: props.blurRadius,
              color: props.shadowColor,
              opacity: props.shadowOpacity,
              xOffset: props.xOffset,
              yOffset: props.yOffset,
            }
          }
      
          await setDoc(docRef, obj, {merge:true});
        });


        setSaving(false)

        document.body.style.cursor="default"
      });
  }

  const downloadScreenshot = async () => {
    const querySnapshot = await getDocs(collection(db, "users"));

    querySnapshot.forEach(async (doc) => {
      if (doc.id === currentUser.uid) {
        const designName = doc.data().allDesigns[searchParams.get("designId")].designName;

        htmlToImage.toPng(props.testRef.current)
          .then(function (dataUrl) {
            download(dataUrl, designName);
          });
        

        // htmlToImage.toJpeg(props.testRef.current, { quality: 0.8 })
        //   .then(function (dataUrl) {
        //     download(dataUrl, designName)
        //   });
      }
    })

  }

  return (
      <SidebarCard
        sidebarWidth={sidebarWidth}
        setSidebarWidth={setSidebarWidth}
        minimisedSidebar={minimisedSidebar}
        setMinimisedSidebar={setMinimisedSidebar}
      >
        <div style={{opacity: `${sidebarWidth === 300 ? 1 : 0}`, transition: `${!minimisedSidebar ? "opacity 2s" : "opacity 0.1s"}`}}>
          <h2 className={styles.subheading}>Background</h2>

          <ul className={styles.options}>
            {/*onClick={() => {props.setBgSelected(!props.bgSelected)}}*/}

            <li><button className="optionsBtnOpener bgBtn"><VscSymbolColor className={styles.icon} /> Background <span className={`optionsBtnOpener bgBtn ${styles.optionValues} ${styles.backgroundValue}`} style={{background: `${props.bgType === "gradient" ? gradient : solid}`}}></span></button> {props.bgSelected && <BackgroundOptions bgGradientRotation={props.bgGradientRotation} setBgGradientRotation={props.setBgGradientRotation} bgType={props.bgType} setBgType={props.setBgType} setBgValueGradient={props.setBgValueGradient} bgValueGradient={props.bgValueGradient} setBgValueSolid={props.setBgValueSolid} bgValueSolid={props.bgValueSolid} />}</li>

            <li><label><BiBorderRadius className={styles.icon} /> Border Radius <span className={styles.optionValues}><input type="number" defaultValue={props.bgBorderRadius} min={0} max={360} className={styles.borderRadiusValue} onInput={(e) => {props.setBgBorderRadius(e.target.value)}} />px</span></label></li>

            {/* <li><label><MdPhotoSizeSelectLarge className={styles.icon} /> Padding <span className={styles.optionValues}><input type="number" max={330} min={0} defaultValue={props.padding} className={styles.borderRadiusValue} onInput={(e) => {props.setPadding(e.target.value)}} />px</span></label></li> */}
            
            {/* onClick={() => {props.setPaddingSelected(!props.paddingSelected)}} */}

            <li><button className="optionsBtnOpener paddingBtn"><MdPhotoSizeSelectLarge className={styles.icon} /> Padding <span className={`optionsBtnOpener paddingBtn ${styles.optionValues}`}>Edit</span></button> {props.paddingSelected && <PaddingOptions linkedPadding={props.linkedPadding} setLinkedPadding={props.setLinkedPadding} setPadding={props.setPadding} setTopPadding={props.setTopPadding} setBottomPadding={props.setBottomPadding} setLeftPadding={props.setLeftPadding} setRightPadding={props.setRightPadding} padding={props.padding} topPadding={props.topPadding} leftPadding={props.leftPadding} bottomPadding={props.bottomPadding} rightPadding={props.rightPadding} />}</li>

            {/* <li><button><BsBorderOuter className={styles.icon} /> Border <span className={styles.optionValues}>Disabled</span></button></li> */}
          </ul>
        </div>

        <div style={{opacity: `${sidebarWidth === 300 ? 1 : 0}`, transition: `${!minimisedSidebar ? "opacity 2s" : "opacity 0.1s"}`}}>
          <h2 className={styles.subheading}>Image</h2>

          <ul className={styles.options}>
            <li><label><BiBorderRadius className={styles.icon} /> Border Radius <span className={styles.optionValues}><input type="number" defaultValue={props.imgBorderRadius} min={0} max={360} className={styles.borderRadiusValue} onInput={(e) => {props.setImgBorderRadius(e.target.value)}} />px</span></label></li>

            {/*onClick={() => {props.setShadowSelected(!props.shadowSelected)}}*/}

            <li><button className="optionsBtnOpener shadowBtn"><HiOutlineDuplicate className={styles.icon} /> Shadow <span className={`optionsBtnOpener shadowBtn ${styles.optionValues}`}>{props.shadowEnabled === "on" ? "Enabled" : "Disabled"}</span></button> {props.shadowSelected && <ShadowOptions shadowEnabled={props.shadowEnabled} setShadowEnabled={props.setShadowEnabled} shadowColor={props.shadowColor} setShadowColor={props.setShadowColor} xOffset={props.xOffset} yOffset={props.yOffset} blurRadius={props.blurRadius} setXOffset={props.setXOffset} setYOffset={props.setYOffset} setBlurRadius={props.setBlurRadius} shadowOpacity={props.shadowOpacity} setShadowOpacity={props.setShadowOpacity} />}</li>

            {/* <li><label><MdPhotoSizeSelectLarge className={styles.icon} /> Width <span className={styles.optionValues}><input type="number" defaultValue={95} className={styles.borderRadiusValue} onInput={(e) => {props.setPadding(e.target.value)}} />px</span></label></li> */}

            {/* <li><button><BsBorderOuter className={styles.icon} /> Border <span className={styles.optionValues}>Disabled</span></button></li> */}
          </ul>
        </div>

        <div className={styles.exportBtnContainer}>
          <button className={`${styles.exportBtn} ${saving ? styles.disabledBtn : ""}`} disabled={saving} onClick={() => {saveDesign()}}>{saving ? "Saving..." : "Save"}</button>
          <button className={styles.exportBtn} onClick={() => {downloadScreenshot()}}>Download</button>
        </div>
      </SidebarCard>
  );
}
